const APPLICANT_URL = variables.serverUrl+"/api/v1/applicants"; 
// const VALIDATE_MAIL_URL = "https://cors-anywhere.herokuapp.com/https://e7pj9mzqll.execute-api.us-west-2.amazonaws.com/dev/validateEmail";
const VALIDATE_MAIL_URL = "https://e7pj9mzqll.execute-api.us-west-2.amazonaws.com/dev/validateEmail";

import Axios from "axios";
import { variables } from "../variables";

export default {
    state: {
        name: "",
        lastName: "",
        mothersLastName: "",
        password: "",
        username: "",
        maritalStatus: "",
        userApplication:"",
        birthDate: "",
        birthPlace: "",
        recommendations: "",
        laboralData: "",
        allApplicationData: ""
    },
    getters: {
        getFullName(state){
            return state.name+' '+state.lastName+' '+state.mothersLastName;
        },
        getName(state){
            return state.name;
        },
        getLastName(state){
            return state.lastName;
        },
        getMothersLastName(state){
            return state.mothersLastName;
        },
        getMaritalStatus(state){
            return state.maritalStatus;
        },
        getBirthDate(state){
            return state.birthDate;
        },
        getBirthPlace(state){
            return state.birthPlace;
        },
        getRecommendations(state){
            return state.recommendations
        },
        getUserApplication(state){
            return state.userApplication;
        },

        getUserLaboralData(state){
            return state.laboralData;
        },

        getAllApplicationData(state){
            return state.allApplicationData;
        }


    },
    mutations: {    
        setName(state, header){
            state.name  = header.name;
        },
        setLastName(state, header){
            state.name = header.name;
        },
        setPassword(state, header){
            state.password = header.password;
        },
        setMaritalState(state, data){
            state.maritalStatus = data;
        },

        setApplicant(state, header){
            state.name = header.name;
            state.lastName = header.lastName;
            state.mothersLastName = header.mothersLastName;
            state.maritalStatus = header.maritalStatus;
            state.birthDate = header.birthDate;
            state.birthPlace = header.birthPlace;
            state.recommendations = header.recommendations;
            state.userApplication = header.application;
            state.laboralData = header.laborData;
            state.allApplicationData = header;
        },
        CleanApplicant(state){
            state.name = "";
            state.lastName = "";
            state.mothersLastName = "";
            state.maritalStatus = "";
            state.birthDate = "";
            state.birthPlace = "";
            state.recommendations = "";
            state.userApplication = "";
            state.laboralData = "";   
            state.allApplicationData = "";   
        }
    },
    actions: {
        async createApplicant(context, applicant){
            let formData = {};

            formData.username = applicant.username;
            formData.userType = "APPLICANT";
            formData.clubCode = "CGTM";

            let response = await Axios.post(`${APPLICANT_URL}/create-account`,  formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'es-MX'
                }
            });
            return response;
        },
        async validateEmail(context, email){

            let response = await Axios.post(VALIDATE_MAIL_URL, { correo: email }, {
                'Content-Type': 'application/json',
            });

            return response;

        },
        async confirmFirstCode(context, code){

            let response = await Axios.post(`${APPLICANT_URL}/confirm-first-code/${code}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'es-MX'
                }
            });

            return response;

        },
        async createNewPassword(context, codepass){
            let response = await Axios.post(`${APPLICANT_URL}/assign-password`, {
                secondCode: codepass.secondcode,
                password: codepass.password
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': 'es-MX'
                }
            });
            return response;
        },
        async checkApplication(context){
            let response = await context.rootGetters.api.get(`${APPLICANT_URL}/check-application`);
            context.commit("setApplicant", response.data.data)
            context.commit("setApplicationData", response.data.data)
            localStorage.setItem('userAllData',  JSON.stringify(response.data.data));
            return response;
        }
    }
}